import { AdminMessage } from "@components/admin/admin-helpers"
import { SessionTicketWidget } from "@components/film/SessionTicketWidget"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Tickets",
  icon: "cart",
  conditions: {
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-tickets", (props) => {
  const sessions = props.film?.sessions || []

  if (!sessions.length && env.admin) {
    return <AdminMessage>No tickets to display</AdminMessage>
  }

  return (
    sessions.length > 0 && (
      <div className="my-6 scroll-mt-[160px]" id="book-tickets-panel">
        <EditableText store="heading" as="h2" defaultValue="Tickets" className="type-title-xs mb-3" />
        <EditableText
          store="description"
          as="p"
          placeholder="Enter an optional ticket description for this event"
          className="type-body-xs mb-3 opacity-80"
        />
        <div className="flex flex-col gap-2 my-3">
          {props.film?.sessions?.map((session, i) => (
            <div key={i}>
              <SessionTicketWidget session={session!} />
            </div>
          ))}
        </div>
      </div>
    )
  )
})
